import { render, staticRenderFns } from "./GroupAccessItem.vue?vue&type=template&id=4620ae98&scoped=true&"
import script from "./GroupAccessItem.vue?vue&type=script&lang=ts&"
export * from "./GroupAccessItem.vue?vue&type=script&lang=ts&"
import style0 from "./GroupAccessItem.vue?vue&type=style&index=0&id=4620ae98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4620ae98",
  null
  
)

export default component.exports